import GlassFrogModel from 'legacy/GlassFrog/GlassFrogModel'

const MeetingHost = GlassFrogModel.extend({}, {
  resourceName: 'meeting_hosts',
  defaults: {},
})

export default MeetingHost
